module.exports = __webpack_public_path__ + "static/media/tubteam2.b068ac3b.jpeg";